import * as Yup from 'yup';

export const CustomerValidation = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  company_name: Yup.string(),
  company_name_in_local: Yup.string(),
  email: Yup.string()
    .nullable(true)
    .email('Email must be a valid email')
    .max(320, 'Email must be at most 320 characters'),
  address1: Yup.string()
    .max(150, 'Address line 1 should not exceed 150 characters')
    .required('Address line 1 is required'),
  address2: Yup.string().max(150),
  address3: Yup.string().max(150),
  city: Yup.string().max(50, 'City should not exceed 50 characters').required('City is required'),
  country_code: Yup.object().required('Country is required'),
  state: Yup.mixed().when('country_code', ([country], schema) => {
    if (country && country.key === 'MYS') {
      return Yup.object().required('State is required');
    } else {
      return Yup.string().max(50, 'State must be a within 1-50 characters').required('State is required');
    }
  }),
  postal_code: Yup.string().max(5, 'Postal Code must be at most 5 characters'),
  phone: Yup.string().max(20, 'Phone must be at most 20 characters').required('Phone is required'),
  registration_type: Yup.object().required('Registration Type is required'),
  registration_number: Yup.string()
    .max(20, 'Registration number must be at most 20 characters')
    .required('Registration Number is required'),
  tin: Yup.string()
    .required('TIN is required')
    .max(14, 'TIN must be at most 14 characters')
    .matches(/^[A-Za-z]{1,2}\d{1,12}$/, 'TIN must start with 1–2 letters followed by up to 12 digits'),
  sst_registration_number: Yup.string().max(35, 'It should not exceed 35 characters'),
});

export const DraftCustomerValidation = Yup.object().shape({
  name: Yup.string(),
  company_name: Yup.string(),
  company_name_in_local: Yup.string(),
  email: Yup.string()
    .nullable(true)
    .email('Email must be a valid email')
    .max(320, 'Email must be at most 320 characters'),
  address1: Yup.string().max(150, 'Address line 1 should not exceed 150 characters'),
  address2: Yup.string().max(150),
  address3: Yup.string().max(150),
  city: Yup.string().max(50, 'City should not exceed 50 characters'),
  country_code: Yup.object(),
  state: Yup.mixed().when('country_code', ([country], schema) => {
    if (country && country.key === 'MYS') {
      return Yup.object();
    } else {
      return Yup.string().max(50, 'State should not exceed 50 characters');
    }
  }),
  postal_code: Yup.string().max(5, 'Postal Code must be at most 5 characters'),
  phone: Yup.string().max(20, 'Phone must be at most 20 characters'),
  registration_type: Yup.object(),
  registration_number: Yup.string().max(20, 'Registration number must be at most 20 characters'),
  tin: Yup.string()
    .max(14, 'TIN must be at most 14 characters')
    .matches(/^[A-Za-z]{1,2}\d{1,12}$/, 'TIN must start with 1–2 letters followed by up to 12 digits'),
  sst_registration_number: Yup.string().max(35, 'It should not exceed 35 characters'),
});

export const B2CCustomerValidation = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  company_name: Yup.string(),
  company_name_in_local: Yup.string(),
  email: Yup.string()
    .email('Email must be a valid email')
    .required('Email is required')
    .max(320, 'Email must be at most 320 characters'),
  address1: Yup.string().required('Address line 1 is required'),
  address2: Yup.string(),
  address3: Yup.string(),
  city: Yup.string().required('City is required'),
  country_code: Yup.object().required('Country is required'),
  state: Yup.mixed().when('country_code', ([country], schema) => {
    if (country && country.key === 'MYS') {
      return Yup.object().required('State is required');
    } else {
      return Yup.string().max(50, 'State must be a within 1-50 characters').required('State is required');
    }
  }),
  postal_code: Yup.string(),
  phone: Yup.string().required('Phone number is required').min(8, 'Phone number must be at least 8 characters'),
  registration_type: Yup.object().required('ID Type is required'),
  registration_number: Yup.string()
    .required('Registration number is required')
    .notOneOf(['NA'], 'NA is not allowed for Registration number'),
  tin: Yup.string()
    .required('TIN is required')
    .max(14, 'TIN must be at most 14 characters')
    .matches(/^[A-Za-z]{1,2}\d{1,12}$/, 'TIN must start with 1–2 letters followed by up to 12 digits')
    .notOneOf(
      ['EI00000000010', 'EI00000000020', 'EI00000000030', 'EI00000000040'],
      'General Tins are not allowed for E-Document',
    ),
  sst_registration_number: Yup.string(),
});
